import { useEffect, useState, } from "react";
import useInView from "../ScrollAnimation";
import ContainerSize from "../container";
import { useNavigate } from "react-router-dom";
import OptimizedImage from "../imageOptimise";

const ServicesHomeConatiner = ({ title,showButton, showTextProp, description, buttonTitle, image1, image2 }) => {
    const [scrollView, setScrollView] = useInView(0.2);
    const [showFirst, setShowFirst] = useState(true);
    const [showText, hidenText] = useState(showTextProp)

    useEffect(() => {
        const interval = setInterval(() => {
            setShowFirst((prev) => !prev);
        }, 2000);

        return () => clearInterval(interval);
    }, []);
    const navigate = useNavigate();

    const handleNavigation = () => {
        navigate("/free-trial");
    };

    return (
        <>
            <ContainerSize>
                <div className="flex flex-col md:flex-row md:justify-between items-center pt-[60px]">

                    {/* Text Content */}
                    <div className="md:w-full md:pl-[55px] w-[350px]  pl-[10px]">
                        <h2
                            ref={scrollView}
                            className={`w-full max-w-[1000px] font-bold text-[26px] sm:text-[36px] md:text-[50px] text-[#1b4a78] transition-all duration-700 tracking-tight ${setScrollView ? "animate-slideDown opacity-100" : "opacity-0"}`}
                        >
                            {title}
                            <span
                                className={`text-[#4da6ff] transition-transform duration-700 ease-in-out inline-block ${showFirst ? "rotate-x-0" : "rotate-x-180"}`}
                            >
                                {showText ? (showFirst ? "Brokers" : "Advanced") : ""}
                            </span>
                        </h2>

                        <p className={`text-[#1b1b1b] mt-4 text-[14px] sm:text-[15px] md:text-[16px] leading-relaxed max-w-[600px] ${setScrollView ? "animate-slideDown opacity-100" : "opacity-0"}`}>
                            {description}
                        </p>

                        <div className="pt-[20px]">
                            {showButton && (
                                <button
                                    onClick={handleNavigation}
                                    className="bg-[#f18801] text-white hover:bg-[#1b4a78] hover:animate-pulse font-semibold py-2 px-6 sm:py-2 sm:px-8 rounded-full text-[14px] sm:text-[16px] transition duration-300 mt-4 inline-block"
                                >
                                    {buttonTitle}
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="md:w-1/2 w-full relative flex flex-col items-center gap-4 pt-9 pt-[40px] md:top-[70px] md:right-[65px]">

                        {/* First Image - Fixed Size */}
                        <div className="relative group z-20 pb-9 w-full flex justify-center right-[30px]">
                            <OptimizedImage
                                src={image1}
                                alt="Smiling Woman with Tablet"
                                className="rounded-lg shadow-lg z-10 mb-2 transform transition-transform duration-500 ease-in-out group-hover:-translate-y-4
      w-[220px] h-[160px] md:w-[350px] md:h-[250px] md:h-[200px] object-cover"
                            />
                        </div>

                        <div className="relative group w-full flex justify-center md:static left-[40px] bottom-[100px]">
                            <OptimizedImage
                                src={image2}
                                alt="Analytics Chart"
                                className="rounded-lg shadow-xl transform transition-transform duration-500 ease-in-out group-hover:-translate-y-4
      w-[220px] h-[160px] md:w-[350px] md:h-[250px] object-cover md:absolute md:bottom-0 md:left-[70px] md:top-[-150px]"
                            />
                        </div>

                    </div>


                </div>
            </ContainerSize>

        </>
    )
}
export default ServicesHomeConatiner